import React, { useState } from "react";
import { FaChevronRight } from "react-icons/fa";
import styles from "./DropDown.module.scss";

const DropDown = () => {
  const [checked, setChecked] = useState(null);
  const [showNestedDropdown, setShowNestedDropdown] = useState(false);

  const dropdownData = [
    "Credit/Debit card (Ending with 2345)",
    "Credit/Debit card (Ending with 8768)",
    "Paypal",
    "Meezan bank account(Ending with 2567)",
    "Jazzcash (Ending with 4533)",
    "Maelano wallet",
    "Gift card",
  ];

  const giftCardOptions = [
    "Eid Gift card(Ending with 2345)",
    "Maelano Gift card(Ending with 8768)",
    "Birthday Gift card(Ending with 3474)",
  ];

  const handleGiftCardClick = () => {
    setShowNestedDropdown(!showNestedDropdown);
  };

  return (
    <div className={styles.dropDown}>
      {dropdownData.map((item, index) => (
        <div className={styles.dropDownItem} key={index}>
          <input
            className="form-check-input me-1"
            type="checkbox"
            name={`dropdown-${index}`}
            onClick={() => setChecked(item)}
            checked={item === checked}
          />
          <p>{item}</p>

          {item === "Gift card" && (
            <FaChevronRight
              size={16}
              className={styles.arrowIcon}
              onClick={handleGiftCardClick}
            />
          )}
        </div>
      ))}

      {showNestedDropdown && (
        <div className={styles.nestedDropDown}>
          {giftCardOptions.map((giftCard, idx) => (
            <div className={styles.dropDownItem} key={idx}>
              <input
                className="form-check-input me-1"
                type="checkbox"
                name={`giftcard-${idx}`}
                onClick={() => setChecked(giftCard)}
                checked={giftCard === checked}
              />
              <p>{giftCard}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DropDown;